import { render, staticRenderFns } from "./statusRules.vue?vue&type=template&id=b6e6e7ee&scoped=true&"
import script from "./statusRules.vue?vue&type=script&lang=js&"
export * from "./statusRules.vue?vue&type=script&lang=js&"
import style0 from "./statusRules.vue?vue&type=style&index=0&id=b6e6e7ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e6e7ee",
  null
  
)

export default component.exports